import { type FC } from 'react';
import { type OmitDeep } from 'type-fest';
import { IconButton } from '@mui/material';
import { Menu } from '@mui/icons-material';

import { PageHeader, type PageHeaderProps } from './page-header';

export type MainPageHeaderProps = OmitDeep<
  PageHeaderProps,
  'navigationIcon'
> & {
  /**
   * Handler for app menu click
   */
  onNavigationIconClick: () => void;
};

export const MainPageHeader: FC<MainPageHeaderProps> = ({
  onNavigationIconClick,

  children,

  ...props
}) => (
  <PageHeader
    navigationIcon={
      <IconButton
        color="inherit"
        aria-label="menu"
        onClick={onNavigationIconClick}
        edge="start"
        sx={{ mr: 0.5 }}>
        <Menu fontSize="large" />
      </IconButton>
    }
    {...props}>
    {children}
  </PageHeader>
);
